<app-auth-layout>
  <div class="login-form">

    <!-- Overlay loader -->
    @if (submitting()) {
      <div class="login-form-overlay">
        <fid-loader size="large" message="Verificando..."></fid-loader>
      </div>
    }

    <!-- Logo -->
    <a routerLink="/login" class="login-logo">
      <img src="fid-seguros-logo.svg" alt="FID Seguros" />
    </a>

    <h1 class="login-title">{{ appTitle }}</h1>

    <!-- Botón único: Keycloak muestra su propia pantalla de login -->
    <div class="login-actions">
      <fid-button
        label="Acceder al Portal Cliente"
        appearance="flat"
        color="accent"
        width="full"
        [disabled]="submitting()"
        (click)="signIn()">
      </fid-button>
    </div>

  </div>
</app-auth-layout>
